import { render, staticRenderFns } from "./ProductWrhsdlvrStatus.vue?vue&type=template&id=0f3742c0&scoped=true&"
import script from "./ProductWrhsdlvrStatus.vue?vue&type=script&lang=js&"
export * from "./ProductWrhsdlvrStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProductWrhsdlvrStatus.vue?vue&type=style&index=0&id=0f3742c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3742c0",
  null
  
)

export default component.exports